import Vue from 'vue'
import VueRouter from 'vue-router'
import router from '../router'
import AuthPlugin from './custom_plugins/auth'

Vue.use(AuthPlugin, {
    tokenGetter: async ( username, password ) => {
        let { data } = await window.axios.post('get-token/', { username, password })
        return data?.token ? data.token : ''
    },
    onLogout: () => {
        // logout может сработать (401 из axios_error_handler) когда пользователь
        // уже находится на Home — push на текущий маршрут кидает NavigationDuplicated,
        // который нужно проглотить, а остальные ошибки навигации пробросить дальше
        router.push({ name: "Home" }).catch(err => {
            if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
                throw err
            }
        })
    }
})
